export default __webpack_public_path__ + "static/media/deal-2.07d7a662.webp";